import { useEffect } from "react";

export default function useKeyDown(handler: (this: Document, ev: KeyboardEvent) => any) {
  useEffect(() => {
    document.addEventListener("keydown", handler);
    // clean up
    return () => {
      document.removeEventListener("keydown", handler);
    };
  }, [handler]);
}
